import Schema from 'AppReact/schema';
import { priority } from 'types';

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  priorities: Schema(priority, 'array', { defaultValue: [] }),
  selectedPriorities: Schema('integer', 'array', { defaultValue: [] }),
};
